import React from "react"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Footer from './Footer';
import { useEffect, useState } from "react"
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {Link, Route, Routes} from 'react-router-dom';
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Nav from './Nav';








const error = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_RIGHT
});
};

const success = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_RIGHT
});
};





export default function Dashboard(props){
  const [projects, setProjects] = useState([])
  const [project, setProject] = useState([])
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [name, setName] = useState();
  const [address, setAddress] = useState();
  const add_project = () =>Create_Project(name, address);

  useEffect(() => {
    (async () => {
      const result = await axios("https://api.tydacomm.com/api/user/projects");
      setProjects(result.data.data);
      
    })();
  }, []);

  const Create_Project = (name, address) => {
    axios
      .post("https://api.tydacomm.com/api/user/create-project", {
        name: name,
        address: address
      })
      .then((response) => {
       
        setProjects(response.data.data);
        console.log(response)
        if(response.data.error){
          error(response.message);
        }else{
          success(response.message)
        }
      });

      

      

      handleClose();
      
     
      
  }

  
   
  



 





  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
     


return (
  <div id="wrapper">
    <Header isSidebarOpen={isSidebarOpen} />
      <ToastContainer />
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          
        <Nav  toggleSidebar={toggleSidebar}/>

    
    <div class="container-fluid">
    

          <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <div class="form-group">
            <input type="text" class="form-control form-control-user" id="name"
              placeholder="Project Name"   onChange={e => setName(e.target.value)} />
          </div>

          <div class="form-group">
            <input type="text" class="form-control form-control-user" id="address"
              placeholder="Project Address"   onChange={e => setAddress(e.target.value)} />
          </div>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={add_project}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    

      <h1 class="h3 mb-4 text-gray-800">Projects</h1>
            <div class="row">
            <div class="col-md-3">
                    <div class="card shadow mb-4">
                        <div class="card-body" style={{textAlign:"center", color:"#000000"}} onClick={handleShow}>
                        
                        <FontAwesomeIcon icon={faPlus}  size="3x" />
                        <br/>
                        Add New Project
                        </div>
                    </div>
                </div>
            {projects.map(project => (
                <div class="col-md-3">
                     <Link to={{ pathname: `/project/${project.id}`, state: project.id }}>
                    <div class="card shadow mb-4">
                        <div class="card-body" style={{textAlign:"center", color:"#000000"}}>
                        <FontAwesomeIcon icon={faBuilding} size="2x" />
                        <br/>
                        <br/>
                        {project.name}<br/>
    
                       

                        </div>
                    </div>
                    </Link>
                </div>
               

            ))}

            
            








            
            </div>
    </div>
   

</div>



<Footer />

</div>
    </div>
  
        
      )
}





 